<template>



            <div class="container" >


                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <b-field label="Select Date" :type="{ 'is-danger': hasError }"
                                         :message="{ 'date is not available': hasError }">
                                    <b-datepicker v-model="date_selected"
                                                  placeholder="Click to select..."
                                                  icon="calendar-today"
                                                  range
                                    >
                                    </b-datepicker>
                                </b-field>
                            </div>
                            <div class="level-item">
                                <b-field label="#">
                                    <b-button type="is-primary is-light">Get Report</b-button>
                                </b-field>
                            </div>
                            <div class="level-item">
                                <b-field label="Clear">
                                    <b-button type="is-danger is-light">Clear</b-button>
                                </b-field>
                            </div>



                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div class="level-item">
                                    <b-field label="Back">
                                        <b-button type="is-success" @click="closeModal">Back To Dashboard Report</b-button>
                                    </b-field>
                                </div>
                            </div>
                        </div>
                    </nav>

                    <hr>


                    <template>


                        <table class="table  is-fullwidth" >

                            <tr>
                                <td colspan="2"><p class="is-size-4 has-text-danger ">Descp </p></td>
                                <td> <p class="is-size-4 has-text-danger">  Count </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Mean </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Std </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Min </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Max </p> </td>
                            </tr>


                            <tr>
                                <td colspan="2"> <p class="is-size-4">Hematology </p></td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- HGB</p></td>
                                <td>  {{getRandomFloatSample()}}</td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}}</td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td> {{getRandomFloatSample()}}  </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- PCV</p></td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}}  </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- RBC</p></td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}}  </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- WBC</p></td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td>{{getRandomFloatSample()}} </td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}} </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- MY CYTE</p></td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}}  </td>
                            </tr>



                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- META</p></td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}}  </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td> {{getRandomFloatSample()}}  </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- SEGS</p></td>
                                <td> {{getRandomFloatSample()}} </td>
                                <td> {{getRandomFloatSample()}} </td>
                                <td> {{getRandomFloatSample()}} </td>
                                <td>{{getRandomFloatSample()}}  </td>
                                <td> {{getRandomFloatSample()}}  </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- LYMPH</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- MONO</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- EOS</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- UNCLASS</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- NUCL RBC</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- RETICS</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- PLATELETS</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- PROTEIN REFRACT</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- RDW</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- MPV</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>


                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- APLT</p></td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                                <td>  {{getRandomFloatSample()}} </td>
                            </tr>


                            <tr>
                                <td colspan="2"> <p class="is-size-4">Blood Chemistry </p></td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- BUN</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- CREATININE</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- GLUCOSE</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- AMYLASE</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- ALT SGPT</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">Urinalysis  </p></td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                                <td> </td>
                            </tr>

                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- PH</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>
                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- SP GR</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>
                            <tr>
                                <td> &nbsp;</td>
                                <td> <p class="is-size-5">- CREATININE</p></td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                                <td> {{getRandomFloatSample()}}</td>
                            </tr>

                        </table>


                        <table class="table  is-fullwidth" >
                            <tr>
                                <td colspan="2"><p class="is-size-4 has-text-danger ">Descp </p></td>
                                <td> <p class="is-size-4 has-text-danger">  Count </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Negative </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Positive </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Suspend </p> </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">BABESIA SP. </p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">EHRLICHIA CANIS </p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">HEPATOZOON CANIS </p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">MICROFILARIA</p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">EHRLICHIA PLATYS</p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">HAEMOBARTONELLA FELIS</p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>





                        </table>


                        <table class="table  is-fullwidth" >
                            <tr>
                                <td colspan="2"><p class="is-size-4 has-text-danger ">Descp </p></td>
                                <td> <p class="is-size-4 has-text-danger">  Assigned  </p> </td>
                                <td> <p class="is-size-4 has-text-danger">  Resulted (Publish) </p> </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">Cytology </p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">Biopsy </p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">Micrology </p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                            <tr>
                                <td colspan="2"> <p class="is-size-4">PCR </p></td>
                                <td> {{getRandomIntSample()}} </td>
                                <td> {{getRandomIntSample()}} </td>
                            </tr>

                        </table>




                        <br>
                        <br>
                        <br>
                    </template>
<!--                        <section>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                    <div class="card">-->
<!--                                        <div class="card-content">-->
<!--                                            <p class="is-size-1">Hemato</p>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="card">-->
<!--                                        <div class="card-content">-->
<!--                                            <p class="is-size-1 has-text-info ">200</p>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                    <div class="card">-->
<!--                                        <div class="card-content">-->
<!--                                            <p class="is-size-1">Blood Chemistry</p>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="card">-->

<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                    <div class="column">-->
<!--                                    </div>-->
<!--                                    <div class="column">-->
<!--                                        <div class="box"><p class="is-size-5">Bun</p></div>-->
<!--                                    </div>-->
<!--                                   <div class="column is-half">-->
<!--                                       <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                   </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">CRETININE</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">GLUCOSE</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">AMYLASE</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">ALT SGPT</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">AST SGOT</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">ALK PHOS</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">CPK</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="columns">-->
<!--                                <div class="column">-->
<!--                                </div>-->
<!--                                <div class="column">-->
<!--                                    <div class="box"><p class="is-size-5">BILEACID FASTING</p></div>-->
<!--                                </div>-->
<!--                                <div class="column is-half">-->
<!--                                    <div class="box"><p class="is-size-5 has-text-info ">15</p></div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                        </section>-->





            </div>


</template>

<script>
    import { getRandomFloat , getRandomInt } from '@/utils.js'
    export default {
        name: "Report001",
        methods:{
            closeModal(){
               this.$emit('close')
            },
            getRandomFloatSample(){
                return getRandomFloat()
            },
            getRandomIntSample(){
                return getRandomInt()
            }
        },
        computed:{

        },
        data(){
           return {
               date_selected : null,
               randomNum : 0,
           }
        }
    }
</script>

<style scoped>

</style>